import { Box, Card, CircularProgress, IconButton, Stack, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CachedIcon from '@mui/icons-material/Cached';
import TrackChangesSharpIcon from '@mui/icons-material/TrackChangesSharp';
import { totalSurveyAttemptAction } from '../../redux/toolkit/dashbaord/totalSurveyAttempt';

const PublisherSurveyAttempted = () => {
     const { data: publisherRevenue ,loading } = useSelector(
        (state) => state.publisherRevenueDetails
      );
    return (
        <Card sx={{ p: 2, color: '#0C6A96' }} >
            <Stack direction='row' justifyContent='space-between' >
                <TrackChangesSharpIcon color='#0C6A96' />
                <Typography sx={{ color: '#5E6C8A', fontFamily: 'Montserrat,sans-serif', fontStyle: 'normal' }} variant='subtitle2'>Attempted Survey</Typography>
                {/* <IconButton sx={{ color: '#5E6C8A' }} onClick={handleRefeash}><CachedIcon /></IconButton> */}
            </Stack>

            {
                loading
                    ? <CircularProgress />
                    : <Box>
                        <Typography variant='h3' color='primary' sx={{ fontWeight: 600, color: '#071D45' }}>{publisherRevenue?.totalAttempted ? publisherRevenue?.totalAttempted : "---"}</Typography>
                    </Box>
            }
        </Card>
    )
}

export default PublisherSurveyAttempted
